<template>
    <div class="header">
        <service-top></service-top>
        <div class="nav">
            <div class="logo">
                <img src='../../../images/logo@2x.png'>
            </div>
            <div class="menu">
                <a-menu v-model="current"
                        mode="horizontal"
                        @click="handleClick">
                    <a-menu-item key="home">首页</a-menu-item>
                    <a-menu-item key="product">产品报价</a-menu-item>
                    <a-menu-item key="about">关于思派</a-menu-item>
                </a-menu>
            </div>
        </div>
    </div>
</template>

<script>
import serviceTop from '@/components/service-top';

export default {
    components: {
        serviceTop
    },
    data() {
        const key = this.$route.meta.part || this.$route.name;
        return {
            current: [key]
        };
    },
    methods: {
        handleClick({ key }) {
            if (key === 'about') {
                window.location.href = 'https://www.medbanks.cn/';
            } else {
                this.$router.push(`/${key}`);
            }
        }
    }
};
</script>

<style lang='scss' scoped>
.header {
    box-shadow: 0px 2px 10px 0px rgba(78, 132, 248, 0.1);
}
.nav {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1160px;
    height: 60px;
    line-height: 60px;

    .logo{
        width: 200px;
        height: 24px;
    }
    .logo img {
        width: 80%;
        height: 80%;
    }
    .menu {
        margin-top: 13px;
        /deep/ .ant-menu-horizontal > .ant-menu-item-selected {
            color: #f36218;
            border-bottom: 2px solid #f36218;
        }
        /deep/ .ant-menu-horizontal > .ant-menu-item:hover {
            color: #f36218;
            border-bottom: 2px solid #f36218;
        }
        /deep/ .ant-menu-horizontal{
            border-bottom: none;
        }
    }
}
</style>